import styled from 'styled-components';

import { Spacing } from '~/src/atomic/obj.constants';

interface BoxProps {
  // src: https://www.w3schools.com/cssref/css3_pr_align-items.asp
  hAlign?: 'stretch' | 'center' | 'flex-start' | 'flex-end' | 'baseline' | 'initial' | 'inherit';
  // src: https://www.w3schools.com/cssref/css3_pr_justify-content.asp
  vAlign?: 'flex-start' | 'flex-end' | 'center' | 'space-between' | 'space-around' | 'initial' | 'inherit';
}

export interface HboxProps extends BoxProps {
  noGrow?: boolean;
}

const HboxStyled = styled.div`
  display: flex;
  flex-direction: row;
  align-content: flex-start;
`;

const HBoxItem = styled.div<HboxProps>`
  flex-direction: column;
  display: flex;
  ${(props) => (!props.noGrow ? 'flex: 1;' : null)}
  justify-content: ${(props) => (props.vAlign ? props.vAlign : 'flex-start')};
  align-items: ${(props) => (props.hAlign ? props.hAlign : 'stretch')};
`;

const HBoxSeparator = styled.div`
  width: ${Spacing.Small};
`;

export const Hbox: typeof HboxStyled & { Item?: typeof HBoxItem; Separator?: typeof HBoxSeparator } = HboxStyled;
Hbox.displayName = 'Hbox';

Hbox.Item = HBoxItem;
Hbox.Item.displayName = 'Hbox.Item';

Hbox.Separator = HBoxSeparator;
Hbox.Separator.displayName = 'Hbox.Separator';

interface SeparatorProps {
  half?: boolean;
}

export const Separator = styled.div<SeparatorProps>`
  height: ${(props) => (props.half ? Spacing.Small : Spacing.Large)};
`;
